import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import {
  getPrecedentDocumentReducer,
  getDocumentVersionsReducer,
  getSearchedDocumentReducer,
  getAllPDF,
  shareDocumentReducer,
  createNewVersionReducer,
  shareSentDocumentReducer,
  getSentDocumentAccessReducer,
  getSearchedVersionsReducer,
  createTemplateReducer,
  getProjectDocumentsReducer,
} from "../Documents/document";
import { DocumentStackReducer } from "../DocumentStackSlice";
import DocumentViewReducer from "../DocumentViewSlice";
import MessageBarReducer from "../MessageBarSlice";
import {
  getAllProjectReducer,
  getProjectDetailsReducer,
  getSearchedProjectReducer,
  getWorkingGroupReducer,
} from "../Projects/project";
import isSearchEnabledReducer from "../SearchEnabledSlice";
import isSearchReducer from "../SearchSlice";
import UploadDocReducer from "../UploadDocSlice";
import { getAllUsersReducer } from "../UserListSlice/userList";
import { getContactsReducer } from "../ContactsSlice/contacts";
import { UpdateUserDetailsReducer, GetUserReducer, UpdateFirstTimeLoginReducer } from "../UserSlice/user";
import GrantPermissionReducer from "../GrantPermissionSlice/grantPermission";
import DeleteProjectReducer from "../ProjectDeleteSlice";
import documentVersionsReducer from "../DocumentVersionSlice";
import WelcomeUserReducer from "../WelcomeUserSlice";
import RedirectLinksReducer from "../RedirectLinksSlice";


const customMiddleware = getDefaultMiddleware({
  serializableCheck: false,
});
export const store: any = configureStore({
  reducer: {
    isSearchEnabled: isSearchEnabledReducer,
    searchFiles: isSearchReducer,
    DocumentView: DocumentViewReducer,
    MessageBarView: MessageBarReducer,
    DocumentStack: DocumentStackReducer,
    UploadDoc: UploadDocReducer,
    GrantPermission: GrantPermissionReducer,
    fetchPrecedentDocument: getPrecedentDocumentReducer,
    fetchProjects: getAllProjectReducer,
    fetchSearchedProject: getSearchedProjectReducer,
    fetchSearchedDocument: getSearchedDocumentReducer,
    fetchSearchedVersions: getSearchedVersionsReducer,
    fetchProjectDetails: getProjectDetailsReducer,
    fetchAllUsers: getAllUsersReducer,
    fetchDocumentVersion: getDocumentVersionsReducer,
    fetchPDF: getAllPDF,
    shareDocument: shareDocumentReducer,
    fetchNewVersionDetails: createNewVersionReducer,
    shareSentDocument: shareSentDocumentReducer,
    getSentVersionAccess: getSentDocumentAccessReducer,
    createTemplate: createTemplateReducer,
    fetchUser: GetUserReducer,
    deleteProject: DeleteProjectReducer,
    fetchDocumentWithVersions: documentVersionsReducer,
    getWorkingGroup: getWorkingGroupReducer,
    contacts: getContactsReducer,
    WelcomeUser: WelcomeUserReducer,
    updateUserDetails: UpdateUserDetailsReducer,
    updateFirstTimeLogin: UpdateFirstTimeLoginReducer,
    redirectLinks: RedirectLinksReducer,
    fetchProjectDocuments: getProjectDocumentsReducer,
  },
  middleware: customMiddleware,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
